/**
 * Shopping Api
 * The Shopping api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { FormRequestModel } from '../model/models';
import { ShoppingSessionActivityModel } from '../model/models';
import { ShoppingSessionRequestModel } from '../model/models';
import { ShoppingSessionResponseModel } from '../model/models';
import { UpdateShoppingSessionLocationModel } from '../model/models';
import { UpdateShoppingSessionProcedureModel } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class SessionService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                    throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerCreateSession(organization: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<ShoppingSessionResponseModel>;
    public shoppingSessionControllerCreateSession(organization: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerCreateSession(organization: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerCreateSession(organization: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling shoppingSessionControllerCreateSession.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<ShoppingSessionResponseModel>(`${this.configuration.basePath}/session/create/${encodeURIComponent(String(organization))}`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param organization 
     * @param xApisecret 
     * @param shoppingSessionRequestModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerCreateSessionWithDetail(organization: string, xApisecret: string, shoppingSessionRequestModel: ShoppingSessionRequestModel, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<ShoppingSessionResponseModel>;
    public shoppingSessionControllerCreateSessionWithDetail(organization: string, xApisecret: string, shoppingSessionRequestModel: ShoppingSessionRequestModel, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerCreateSessionWithDetail(organization: string, xApisecret: string, shoppingSessionRequestModel: ShoppingSessionRequestModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerCreateSessionWithDetail(organization: string, xApisecret: string, shoppingSessionRequestModel: ShoppingSessionRequestModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling shoppingSessionControllerCreateSessionWithDetail.');
        }
        if (xApisecret === null || xApisecret === undefined) {
            throw new Error('Required parameter xApisecret was null or undefined when calling shoppingSessionControllerCreateSessionWithDetail.');
        }
        if (shoppingSessionRequestModel === null || shoppingSessionRequestModel === undefined) {
            throw new Error('Required parameter shoppingSessionRequestModel was null or undefined when calling shoppingSessionControllerCreateSessionWithDetail.');
        }

        let headers = this.defaultHeaders;
        if (xApisecret !== undefined && xApisecret !== null) {
            headers = headers.set('x-apisecret', String(xApisecret));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<ShoppingSessionResponseModel>(`${this.configuration.basePath}/session/create-detail/${encodeURIComponent(String(organization))}`,
            shoppingSessionRequestModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerGetInsurance(xSessionid: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any>;
    public shoppingSessionControllerGetInsurance(xSessionid: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<any>>;
    public shoppingSessionControllerGetInsurance(xSessionid: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerGetInsurance(xSessionid: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerGetInsurance.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/session/insurance`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerGetSession(xSessionid: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<ShoppingSessionResponseModel>;
    public shoppingSessionControllerGetSession(xSessionid: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerGetSession(xSessionid: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<ShoppingSessionResponseModel>>;
    public shoppingSessionControllerGetSession(xSessionid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerGetSession.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ShoppingSessionResponseModel>(`${this.configuration.basePath}/session`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param shoppingSessionActivityModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerLogActivity(xSessionid: string, shoppingSessionActivityModel: ShoppingSessionActivityModel, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<any>;
    public shoppingSessionControllerLogActivity(xSessionid: string, shoppingSessionActivityModel: ShoppingSessionActivityModel, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<HttpResponse<any>>;
    public shoppingSessionControllerLogActivity(xSessionid: string, shoppingSessionActivityModel: ShoppingSessionActivityModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerLogActivity(xSessionid: string, shoppingSessionActivityModel: ShoppingSessionActivityModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerLogActivity.');
        }
        if (shoppingSessionActivityModel === null || shoppingSessionActivityModel === undefined) {
            throw new Error('Required parameter shoppingSessionActivityModel was null or undefined when calling shoppingSessionControllerLogActivity.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/activity`,
            shoppingSessionActivityModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param updateShoppingSessionLocationModel
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerUpdateLocation(xSessionid: string, updateShoppingSessionLocationModel: UpdateShoppingSessionLocationModel, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any>;
    public shoppingSessionControllerUpdateLocation(xSessionid: string, updateShoppingSessionLocationModel: UpdateShoppingSessionLocationModel, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<any>>;
    public shoppingSessionControllerUpdateLocation(xSessionid: string, updateShoppingSessionLocationModel: UpdateShoppingSessionLocationModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerUpdateLocation(xSessionid: string, updateShoppingSessionLocationModel: UpdateShoppingSessionLocationModel, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerUpdateLocation.');
        }
        if (updateShoppingSessionLocationModel === null || updateShoppingSessionLocationModel === undefined) {
            throw new Error('Required parameter updateShoppingSessionLocationModel was null or undefined when calling shoppingSessionControllerUpdateLocation.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/location`,
            updateShoppingSessionLocationModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param updateShoppingSessionProcedureModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerUpdateProcedures(xSessionid: string, updateShoppingSessionProcedureModel: UpdateShoppingSessionProcedureModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public shoppingSessionControllerUpdateProcedures(xSessionid: string, updateShoppingSessionProcedureModel: UpdateShoppingSessionProcedureModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public shoppingSessionControllerUpdateProcedures(xSessionid: string, updateShoppingSessionProcedureModel: UpdateShoppingSessionProcedureModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerUpdateProcedures(xSessionid: string, updateShoppingSessionProcedureModel: UpdateShoppingSessionProcedureModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerUpdateProcedures.');
        }
        if (updateShoppingSessionProcedureModel === null || updateShoppingSessionProcedureModel === undefined) {
            throw new Error('Required parameter updateShoppingSessionProcedureModel was null or undefined when calling shoppingSessionControllerUpdateProcedures.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/session/procedures`,
            updateShoppingSessionProcedureModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xSessionid 
     * @param formRequestModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingSessionControllerVerifyInsurance(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any>;
    public shoppingSessionControllerVerifyInsurance(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<any>>;
    public shoppingSessionControllerVerifyInsurance(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerVerifyInsurance(xSessionid: string, formRequestModel: FormRequestModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerVerifyInsurance.');
        }
        if (formRequestModel === null || formRequestModel === undefined) {
            throw new Error('Required parameter formRequestModel was null or undefined when calling shoppingSessionControllerVerifyInsurance.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/insurance/verify`,
            formRequestModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public shoppingSessionControllerManualBenefits(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any>;
    public shoppingSessionControllerManualBenefits(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<any>>;
    public shoppingSessionControllerManualBenefits(xSessionid: string, formRequestModel: FormRequestModel, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<any>>;
    public shoppingSessionControllerManualBenefits(xSessionid: string, formRequestModel: FormRequestModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xSessionid === null || xSessionid === undefined) {
            throw new Error('Required parameter xSessionid was null or undefined when calling shoppingSessionControllerVerifyInsurance.');
        }
        if (formRequestModel === null || formRequestModel === undefined) {
            throw new Error('Required parameter formRequestModel was null or undefined when calling shoppingSessionControllerVerifyInsurance.');
        }

        let headers = this.defaultHeaders;
        if (xSessionid !== undefined && xSessionid !== null) {
            headers = headers.set('x-sessionid', String(xSessionid));
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/insurance/manualBenefits`,
            formRequestModel,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public viewedAmaNotice(sessionId: string): Observable<any> {
        if (sessionId === null || sessionId === undefined || sessionId === '') {
            throw new Error('Required parameter sessionId was missing when calling viewedAmaNotice.');
        }

        const { withCredentials } = this.configuration;
        let headers = this.defaultHeaders;
        headers = headers.set('x-sessionid', String(sessionId));

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/viewedAmaNotice`, null,
            { withCredentials, headers }
        );
    }

    public estimateDisclaimerAcknowledged(sessionId: string): Observable<any> {
        if (sessionId === null || sessionId === undefined || sessionId === '') {
            throw new Error('Required parameter sessionId was missing when calling estimateDisclaimerAcknowledged.');
        }

        const { withCredentials } = this.configuration;
        let headers = this.defaultHeaders;
        headers = headers.set('x-sessionid', String(sessionId));

        return this.httpClient.post<any>(`${this.configuration.basePath}/session/estimateDisclaimerAcknowledged`, null,
            { withCredentials, headers }
        );
    }
}
